import * as React from "react";
import * as persistentValueService from "core/services/site/persistentvalue";
import { useSessionContext } from "ui/context/SessionContext";
import * as localStorageKeys from "core/constants/localStorageKeys";

interface HookReturn {
    onCompleted(): void;
    completed: boolean | undefined;
}

const getCompletedFromStorage = (): string[] => {
    const completedString = localStorage.getItem(localStorageKeys.ONBOARDING);
    if (completedString) {
        return JSON.parse(completedString) as string[];
    }
    return [];
};

const saveCompletedtoStorage = (key: string) => {
    const completedArr = getCompletedFromStorage();
    const newCompletedArr = [...completedArr, key];
    localStorage.setItem(
        localStorageKeys.ONBOARDING,
        JSON.stringify(newCompletedArr),
    );
};

const useOnboarding = (key: string): HookReturn => {
    const sessionContext = useSessionContext();

    const [completed, setCompleted] = React.useState<boolean>();

    const onCompleted = async (): Promise<void> => {
        setCompleted(true);
        saveCompletedtoStorage(key);
        if (sessionContext.session?.token) {
            persistentValueService.set(sessionContext.session.token, key, true);
        }
    };
    const checkIfCompleted = async (): Promise<void> => {
        const completedArr = getCompletedFromStorage();
        const completedInStorage = completedArr.some((entry) => entry === key);
        if (completedInStorage) {
            setCompleted(true);
            return;
        }
        if (!sessionContext.session?.token) {
            return;
        }
        const result = await persistentValueService.get(
            sessionContext.session.token,
            key,
        );
        if (result.value) {
            setCompleted(true);
            saveCompletedtoStorage(key);
        } else {
            setCompleted(false);
        }
    };

    React.useEffect(() => {
        checkIfCompleted();
    }, []);

    return {
        onCompleted,
        completed,
    };
};
export default useOnboarding;
